import { render } from "./EditDimension.vue?vue&type=template&id=afa10aca&ts=true"
import script from "./EditDimension.vue?vue&type=script&lang=ts"
export * from "./EditDimension.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__